import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.replace";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { mapGetters } from "vuex";

var version = require("element-ui/package.json").version; // element-ui version from node_modules


var ORIGINAL_THEME = "#409EFF"; // default color

export default function () {
  return {
    data: function data() {
      return {
        themeVal: ORIGINAL_THEME
      };
    },
    created: function created() {
      this.themeVal = this.colorName;
    },
    watch: {
      themeVal: function themeVal(val, oldVal) {
        this.$store.commit("SET_COLOR_NAME", val);
        this.updateTheme(val, oldVal);
      }
    },
    computed: _objectSpread({}, mapGetters(["colorName"])),
    methods: {
      updateTheme: function updateTheme(val, oldVal) {
        var _this = this;

        if (typeof val !== "string") return;
        var head = document.getElementsByTagName("head")[0];
        var themeCluster = this.getThemeCluster(val.replace("#", ""));
        var originalCluster = this.getThemeCluster(oldVal.replace("#", ""));

        var getHandler = function getHandler(variable, id) {
          return function () {
            var originalCluster = _this.getThemeCluster(ORIGINAL_THEME.replace("#", ""));

            var newStyle = _this.updateStyle(_this[variable], originalCluster, themeCluster);

            var styleTag = document.getElementById(id);

            if (!styleTag) {
              styleTag = document.createElement("style");
              styleTag.setAttribute("id", id);
              head.appendChild(styleTag);
            }

            styleTag.innerText = newStyle;
          };
        };

        var chalkHandler = getHandler("chalk", "chalk-style");

        if (!this.chalk) {
          var url = "/cdn/element-ui/".concat(version, "/theme-chalk/index.css");
          this.getCSSString(url, chalkHandler, "chalk");
        } else {
          chalkHandler();
        }

        var link = [].slice.call(document.getElementsByTagName("head")[0].getElementsByTagName("link"));

        var _loop = function _loop(i) {
          var style = link[i];

          if (style.href.includes('css')) {
            _this.getCSSString(style.href, function (innerText) {
              var originalCluster = _this.getThemeCluster(ORIGINAL_THEME.replace("#", ""));

              var newStyle = _this.updateStyle(innerText, originalCluster, themeCluster);

              var styleTag = document.getElementById(i);

              if (!styleTag) {
                styleTag = document.createElement("style");
                styleTag.id = i;
                styleTag.innerText = newStyle;
                head.appendChild(styleTag);
              }
            });
          }
        };

        for (var i = 0; i < link.length; i++) {
          _loop(i);
        }

        var styles = [].slice.call(document.querySelectorAll("style"));
        styles.forEach(function (style) {
          var innerText = style.innerText;
          if (typeof innerText !== "string") return;
          style.innerText = _this.updateStyle(innerText, originalCluster, themeCluster);
        });
      },
      updateStyle: function updateStyle(style, oldCluster, newCluster) {
        var newStyle = style;
        oldCluster.forEach(function (color, index) {
          newStyle = newStyle.replace(new RegExp(color, "ig"), newCluster[index]);
        });
        return newStyle;
      },
      getCSSString: function getCSSString(url, callback, variable) {
        var _this2 = this;

        var xhr = new XMLHttpRequest();

        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4 && xhr.status === 200) {
            if (variable) {
              _this2[variable] = xhr.responseText.replace(/@font-face{[^}]+}/, "");
            }

            callback(xhr.responseText);
          }
        };

        xhr.open("GET", url);
        xhr.send();
      },
      getThemeCluster: function getThemeCluster(theme) {
        var tintColor = function tintColor(color, tint) {
          var red = parseInt(color.slice(0, 2), 16);
          var green = parseInt(color.slice(2, 4), 16);
          var blue = parseInt(color.slice(4, 6), 16);

          if (tint === 0) {
            // when primary color is in its rgb space
            return [red, green, blue].join(",");
          } else {
            red += Math.round(tint * (255 - red));
            green += Math.round(tint * (255 - green));
            blue += Math.round(tint * (255 - blue));
            red = red.toString(16);
            green = green.toString(16);
            blue = blue.toString(16);
            return "#".concat(red).concat(green).concat(blue);
          }
        };

        var shadeColor = function shadeColor(color, shade) {
          var red = parseInt(color.slice(0, 2), 16);
          var green = parseInt(color.slice(2, 4), 16);
          var blue = parseInt(color.slice(4, 6), 16);
          red = Math.round((1 - shade) * red);
          green = Math.round((1 - shade) * green);
          blue = Math.round((1 - shade) * blue);
          red = red.toString(16);
          green = green.toString(16);
          blue = blue.toString(16);
          return "#".concat(red).concat(green).concat(blue);
        };

        var clusters = [theme];

        for (var i = 0; i <= 9; i++) {
          clusters.push(tintColor(theme, Number((i / 10).toFixed(2))));
        }

        clusters.push(shadeColor(theme, 0.1));
        return clusters;
      }
    }
  };
}